import { render, staticRenderFns } from "./DeviceFormat.vue?vue&type=template&id=15f00596&scoped=true"
import script from "./DeviceFormat.vue?vue&type=script&lang=js"
export * from "./DeviceFormat.vue?vue&type=script&lang=js"
import style0 from "./DeviceFormat.vue?vue&type=style&index=0&id=15f00596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f00596",
  null
  
)

export default component.exports